import http from '../../../services/http';
import forResponse from '../../../utils/forResponse';
import { FETCH_VIDEO_SEGMENT_BY_ID } from '../../../constants/apiUrls/apiUrls';


export default (id, affiliatePartnerCode) => {
  const url = FETCH_VIDEO_SEGMENT_BY_ID.replace('{id}', id);
  const queryParams = { affiliatePartnerCode };

  return forResponse(http.get(url, { params: queryParams }));
};
